import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import { Toggle } from "../../../../../components/inputs/toggle/toggle";
import Card from "../../../../../components/layouts/card/card";
import { Note, NOTE_TYPE } from "../../../../../components/note/note";
import DashTranslation from "../../../../../dashboard-translation/dashboard-translaton";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import currentPortalStore from "../../../../../stores/current-portal-store";
import currentAccountStore from "../../../../accounts/stores/current-account-store";

interface IProps {
    onExpandClick: (expanded: boolean) => void;
    isExpanded: boolean;
    dataName?: string; /** used by Candu to target an element */
}

const ApiCard: React.FC<IProps> = ({ onExpandClick, isExpanded, dataName }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-settings-store';

    const storeSetting = currentPortalStore.setting;

    const notificationOnlyModeSettingStore = currentPortalStore.setting?.notificationOnlyModeSettingStore;

    return <Card
        toolbar={{
            title: (
                <FontBody1 variant={FONT_VARIANT.BOLD}>
                    <DashTranslation translationKey="API" scope={pageScope} />
                </FontBody1>
            )
        }}
        expandCallback={onExpandClick}
        isExpanded={isExpanded}
        dataName={dataName}
    >
        {
          currentAccountStore.isSysAdmin && (
            <>
            <FormFieldLine
              label={getTranslation('STRICT_API_TYPES', pageScope)}
              note={getTranslation('WHEN_ON_RETURNGO_API_MORE_STRICT_WITH_RETURN_TYPES', pageScope)}
              dataName="strict-api-types"
          >
              <Toggle
                  checked={storeSetting?.apiCollectionsAsArray}
                  onChange={storeSetting?.setApiCollectionsAsArray}
                  label={getTranslation('STRICT_API_TYPES', pageScope)}
              />
          </FormFieldLine>
          <Note
            type={NOTE_TYPE.WARNING}
            body={getTranslation('MIGHT_HELP_SOLVE_LISTS_AS_MAP_WITH_NUMERIC_KEYS_INSTEAD_ARRAY', pageScope)}
          />
        </>
          )
      }
        <FormFieldLine
          label={getTranslation('NOTIFICATION_ONLY_MODE_IS_ACTIVE', pageScope)}
          note={getTranslation('NOTIFICATION_ONLY_MODE_IS_ACTIVE_NOTE', pageScope)}
          dataName="notification-only-mode-is-active"
        >
            <Toggle
              label=""
              checked={notificationOnlyModeSettingStore?.isActive}
              onChange={notificationOnlyModeSettingStore?.setIsActive}
            />
        </FormFieldLine>
        {
          notificationOnlyModeSettingStore?.isActive && (
            <>
                <FormFieldLine
                  label={getTranslation('REFUND_TO_PAYMENT_METHOD_NOTIFY_ONLY', pageScope)}
                  note={getTranslation('REFUND_TO_PAYMENT_METHOD_NOTIFY_ONLY_NOTE', pageScope)}
                  dataName="refund-to-payment-method-notify-only"
                >
                    <Toggle
                      label=""
                      checked={notificationOnlyModeSettingStore?.refundToPaymentMethod}
                      onChange={notificationOnlyModeSettingStore?.setRefundToPaymentMethod}
                    />
                </FormFieldLine>

                <FormFieldLine
                  label={getTranslation('REFUND_TO_STORE_CREDIT_NOTIFY_ONLY', pageScope)}
                  note={getTranslation('REFUND_TO_STORE_CREDIT_NOTIFY_ONLY_NOTE', pageScope)}
                  dataName="refund-to-store-credit-notify-only"
                >
                    <Toggle
                      label=""
                      checked={notificationOnlyModeSettingStore?.refundToStoreCredit}
                      onChange={notificationOnlyModeSettingStore?.setRefundToStoreCredit}
                    />
                </FormFieldLine>

                <FormFieldLine
                  label={getTranslation('REFUND_TO_GIFT_CARD_NOTIFY_ONLY', pageScope)}
                  note={getTranslation('REFUND_TO_GIFT_CARD_NOTIFY_ONLY_NOTE', pageScope)}
                  dataName="refund-to-gift-card-notify-only"
                >
                    <Toggle
                      label=""
                      checked={notificationOnlyModeSettingStore?.refundToGiftCard}
                      onChange={notificationOnlyModeSettingStore?.setRefundToGiftCard}
                    />
                </FormFieldLine>
            </>
          )
        }
      </Card>
    }

export default ApiCard;
